<bl-page-card-container
  data-smartpresentation="container-pagina"
  id="lancamentos-rejeitados-fornecimento-direto"
  backNavigation=".."
  [showTooltip]="true"
  [tooltipKey]="pageTooltip"
  (onCopyUrlFilters)="onCopyUrlFilters()"
>
  <ng-container header>
    <div class="filters-row flex align-items-center">
      <ag-views-toolbar [grid]="agGrid" [gridKey]="GRID_KEY" class="mr-2"></ag-views-toolbar>

      <div class="flex align-items-center mr-2 mb-2">
        <p-multiSelect
          display="chip"
          optionLabel="label"
          optionValue="value"
          [options]="motivoGlosaOptions"
          [(ngModel)]="selectedRejeicoesArquivo"
          dropdownIcon="pi pi-angle-down"
          placeholder="Rejeições do arquivo"
          styleClass="text-sm"
          [filter]="true"
          (ngModelChange)="onFilterChange()"
          [style]="{ width: '230px', height: '35.38px' }"
          [panelStyle]="{ width: '420px', 'max-width': 'calc(100vw - 2rem)' }"
          appendTo="body"
        ></p-multiSelect>
      </div>

      <div class="flex align-items-center mr-2 mb-2">
        <p-multiSelect
          display="chip"
          optionLabel="label"
          optionValue="value"
          [options]="motivoGlosaOptions"
          [(ngModel)]="selectedRejeicoesGuia"
          dropdownIcon="pi pi-angle-down"
          placeholder="Rejeições da guia"
          styleClass="text-sm"
          [filter]="true"
          (ngModelChange)="onFilterChange()"
          [style]="{ width: '220px', height: '35.38px' }"
          [panelStyle]="{ width: '420px', 'max-width': 'calc(100vw - 2rem)' }"
          appendTo="body"
        ></p-multiSelect>
      </div>

      <div class="flex align-items-center mr-2 mb-2">
        <p-multiSelect
          display="chip"
          optionLabel="label"
          optionValue="value"
          [options]="motivoGlosaOptions"
          [(ngModel)]="selectedRejeicoesItem"
          dropdownIcon="pi pi-angle-down"
          placeholder="Rejeições do item"
          styleClass="text-sm"
          [filter]="true"
          (ngModelChange)="onFilterChange()"
          [style]="{ width: '220px', height: '35.38px' }"
          [panelStyle]="{ width: '420px', 'max-width': 'calc(100vw - 2rem)' }"
          appendTo="body"
        ></p-multiSelect>
      </div>

      <p-floatlabel variant="on" class="mr-2 mb-2">
        <p-select
          size="small"
          class="p-inputwrapper-filled"
          [options]="seqLanctoGuiaOptions"
          [(ngModel)]="selectedSeqLanctoGuia"
          dropdownIcon="pi pi-angle-down"
          (ngModelChange)="onFilterChange()"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
        ></p-select>
        <label>Lançamento</label>
      </p-floatlabel>

      <bl-competencia
        class="mr-2 mb-2"
        [competencia]="competenciaRange[0]"
        [competenciaFinal]="competenciaRange[1]"
        (apply)="competenciaChanged($event)"
      ></bl-competencia>

      <button
        data-smartpresentation="botao-pesquisar"
        pButton
        type="button"
        icon="pi pi-search"
        iconPos="left"
        label="Pesquisar"
        class="mr-4 mb-2 p-button p-button-md"
        [ngClass]="{ 'p-disabled': !filterChanged }"
        [disabled]="!filterChanged"
        (click)="reloadData(true)"
      ></button>

      <bl-pesquisar-input class="mr-4 mb-2" (onSearch)="onSearch($event)" [disabled]="!rowData?.length">
      </bl-pesquisar-input>

      <button
        class="p-button p-button-outlined p-button-icon-only mr-2 mb-2"
        (click)="exportExcel()"
        pTooltip="Exportar Listagem como XLSX"
        tooltipPosition="bottom"
        [disabled]="!rowData?.length"
      >
        <i class="pi pi-file-excel"></i>
      </button>

      <button
        data-smartpresentation="botao-tela-cheia"
        class="p-button p-button-outlined p-button-icon-only mb-2"
        (click)="toggleFullscreen()"
        pTooltip="Tela Cheia"
        tooltipPosition="bottom"
      >
        <i
          class="pi"
          [ngClass]="{ 'pi-window-maximize': !(fullscreen$ | async), 'pi-window-minimize': (fullscreen$ | async) }"
        >
        </i>
      </button>
    </div>
  </ng-container>

  <div class="flex flex-column flex-1 min-h-0">
    <div class="grid-wrapper">
      <ag-grid-angular
        #agGrid
        data-smartpresentation="ag-grid"
        class="ag-theme-balham w-full h-full"
        [style.height]="gridHeight$ | async"
        [rowData]="rowData"
        [gridOptions]="gridOptions"
        [overlayLoadingTemplate]="firstLoad ? 'Clique em Pesquisar para exibir os registros' : null"
      >
      </ag-grid-angular>
    </div>
  </div>
</bl-page-card-container>
